import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import parse from "html-react-parser";
import alrajhi_logo from "assets/images/alrajhi_logo.svg";
import chevron_down from "assets/images/chevron_down.svg";
import right_arrow from "assets/images/right_arrow.svg";
import alrajhi247 from "assets/images/alrajhi247.png";
import alrajhicashbiz247 from "assets/images/alrajhicashbiz247.png";
import { PrimaryButton } from "components/buttons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Accordion, Dropdown, Offcanvas } from "react-bootstrap";
import {
  forwardRef,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { useMediaQuery } from "react-responsive";
import {
  personalMenu,
  rizeMenu,
  digitalBankingMenu,
  aboutUsMenu,
  businessMenu,
} from "constants";
import _, { isArray } from "lodash";
import { PillRadio } from "components/radio";
import { tabItems } from "constants";
import TabContext from "context/TabContext";
import axios from "axios";

const CustomToggle = forwardRef(({ children, onClick }, ref) => (
  <PrimaryButton
    ref={ref}
    align="end"
    text="Login"
    icon={chevron_down}
    id="login-button"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  />
));

function MainHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const { tabState } = useContext(TabContext);
  const isMobile = useMediaQuery({ maxWidth: "1200px" });
  const isTabletSize = useMediaQuery({ minWidth: 768, maxWidth: 1200 });
  const isMobileSize = useMediaQuery({ maxWidth: 767 });

  const { pathname } = location;
  const [tab, setTab] = tabState;

  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [style, setStyle] = useState({ display: "none" });
  const [tabDesktopContent, setTabDesktopContent] = useState([]);
  const [showTeaser, setShowTeaser] = useState(false);
  const [desktopImage, setDesktopImage] = useState("");
  const [mobileImage, setMobileImage] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [activeKey, setActiveKey] = useState('100'); 
  const [activeParent, setActiveParent] = useState(null); 

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    if (pathname === "/") {
      window.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    } else {
      setIsScrolled(true);
    }
  }, [pathname]);

  useEffect(() => {
    if (startDate && expiryDate) {
      const checkDateRange = () => {
        const currentDate = new Date();
        // Check if the current date is between the start and expiry dates
        if (currentDate >= startDate && currentDate <= expiryDate) {
          setShowTeaser(true);
        } else {
          setShowTeaser(false);
        }
      };

      // Initial check
      checkDateRange();

      // Set an interval to check the date every second
      const intervalId = setInterval(checkDateRange, 1000);

      // Cleanup interval when component unmounts
      return () => clearInterval(intervalId);
    }
  }, [startDate, expiryDate]);

  useEffect(() => {
    const fetchFestivesTeaser = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_CMS_BASE_URL}/festives-teasers?populate=*`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
            },
          }
        );
        const jsonResponse = response.data.data[0];

        setStartDate(new Date(jsonResponse?.startDate)); // Assuming the API returns ISO date strings
        setExpiryDate(new Date(jsonResponse?.endDate));
        setDesktopImage(jsonResponse?.imageDesktopURL);
        setMobileImage(jsonResponse?.imageMobileURL);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchFestivesTeaser();
  }, []);

  const LoginButton = ({ popupStyle }) => (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
        Dropdown Button
      </Dropdown.Toggle>
      <Dropdown.Menu style={popupStyle}>
        <Dropdown.Item
          eventKey="1"
          onClick={() =>
            window.open(
              "https://www.alrajhi24seven.com.my/iportalweb/iRetail@1"
            )
          }
        >
          <div className="d-flex align-items-center justify-content-between">
            <img
              src={alrajhi247}
              width="200"
              className="d-inline-block align-top margin-right-5px"
              alt="plus"
            />
            <img
              src={right_arrow}
              width="18"
              className="d-inline-block align-top margin-right-5px"
              alt="plus"
            />
          </div>
        </Dropdown.Item>
        <Dropdown.Item
          eventKey="2"
          onClick={() =>
            window.open(
              "https://www.alrajhicashbiz24seven.com.my/iportalweb/CBXLogin.jsp"
            )
          }
        >
          <div className="d-flex align-items-center justify-content-between border-top">
            <img
              src={alrajhicashbiz247}
              width="200"
              className="d-inline-block align-top margin-right-5px"
              alt="plus"
            />
            <img
              src={right_arrow}
              width="18"
              className="d-inline-block align-top margin-right-5px"
              alt="plus"
            />
          </div>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );

  const convertToMobileMenu = tabDesktopContent.map((content) => {
    let children =
      _.isArray(content.children) &&
      content.children.flatMap((item) => item.children);
    if (content.title === "Rize") {
      children = rizeMenu;
    }
    return {
      id: content.id,
      title: content.title,
      parent: content.parent,
      path: content.path,
      children,
    };
  });

  const handleNavigateHome = () => {
    setTab(0);
    navigate("/");
    setTabDesktopContent(personalMenu);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setActiveParent(null);
    setActiveKey('100');
  };

  const handleTabMenu = () => {
    if (pathname.includes("/rize")) {
      setTabDesktopContent(rizeMenu);
      setTab(3);
      return;
    } else if (pathname.includes("/business/")) {
      setTab(1);
      setTabDesktopContent(businessMenu);
    } else if (
      pathname.includes("/about") ||
      pathname.includes("/news") ||
      pathname.includes("/financial-report")
    ) {
      setTab(2);
      setTabDesktopContent(aboutUsMenu);
    } else if (
      pathname.includes("/digital") ||
      pathname.includes("/coming-soon") ||
      pathname.includes("/virtualbanking")
    ) {
      setTab(3);
      setTabDesktopContent(digitalBankingMenu);
    } else if (
      pathname.includes("/enquiry") ||
      pathname.includes("/personal") ||
      pathname.includes("/e-application-form")
    ) {
      setTab(0);
      setTabDesktopContent(personalMenu);
    } else if (tab === 0) {
      setTabDesktopContent(personalMenu);
    }
  };

  useEffect(() => {
    handleTabMenu();
  }, [pathname]);

  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  const fetchPromotionsFromCMS = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/promotion-and-campaigns?sort=createdAt:desc&populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await axios.get(
          "https://www.alrajhibank.com.my/assets/json/promotions.json"
        );

        const cmsPromotions = await fetchPromotionsFromCMS();
        const jsonResponse = response.data;

        const generatePromotionsPath = [...cmsPromotions, ...jsonResponse].map(
          (promotion) => ({
            title: promotion.title ? promotion.title : promotion.pageTitle,
            path: promotion.href || `/personal/promotions/${promotion.slug}`,
          })
        );

        const promotionMenu = {
          id: 5,
          title: "Promotions",
          parent: "/personal/promotions",
          children: [
            {
              type: "PROMOTIONS",
              children: generatePromotionsPath,
            },
          ],
        };

        if (!personalMenu.find((x) => x.id === 5)) {
          personalMenu.splice(4, 0, promotionMenu);
        }

        // setTabDesktopContent(personalMenu);
        handleTabMenu();
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchPromotions();
  }, []);

  return (
    <header style={{ position: "sticky", top: 0, zIndex: "999" }}>
      <div className={isScrolled ? "header-white" : "header-transparent"}>
        {!isMobile && (
          <div className="container p-0">
            <div
              className={`w-100 d-inline-flex justify-content-between pb-1 ${
                pathname === "/"
                  ? "horizontal-line-white"
                  : "horizontal-line-grey"
              }`}
            >
              <div className="pt-2">
                <PillRadio
                  items={tabItems}
                  setTab={setTab}
                  setTabDesktopContent={setTabDesktopContent}
                  active={tab}
                />
              </div>
              {showTeaser && (
                <img
                  src={desktopImage}
                  alt=""
                  className="branding festive-desktop"
                />
              )}
              <div>
                <Navbar expand="lg" className=" d-none d-lg-block">
                  <Container>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                      <Nav className="me-auto delete-anchor-style">
                        <Nav.Link active={pathname === "/career"}>
                          <Link to="/career">Career</Link>
                        </Nav.Link>
                        <Nav.Link active={pathname === "/news"}>
                          <Link to="/news">News</Link>
                        </Nav.Link>
                        <Nav.Link active={pathname === "/contact-us"}>
                          <Link to="/contact-us">Contact Us</Link>
                        </Nav.Link>
                        <Nav.Link
                          target="blank"
                          href="https://www.alrajhibank.com.sa/en"
                        >
                          Global Site
                        </Nav.Link>
                      </Nav>
                    </Navbar.Collapse>
                  </Container>
                </Navbar>
              </div>
            </div>
          </div>
        )}
        <header id="header" className={`header d-flex align-items-center py-3`}>
          {/* desktop navigation */}
          <div className="container container-xl position-relative d-flex align-items-center p-sm-0">
            <div
              onClick={() => handleNavigateHome()}
              className="logo d-flex align-items-center"
            >
              <img
                src={alrajhi_logo}
                alt=""
                className="branding cursor-pointer"
              />
              {showTeaser && isTabletSize && (
                <img src={desktopImage} alt="" className="festive-tablet" />
              )}
              {showTeaser && isMobileSize && (
                <img src={mobileImage} alt="" className="festive-mobile" />
              )}
            </div>

            <nav id="navmenu" className="navmenu">
              <ul
                onMouseEnter={(e) => {
                  setStyle({ display: "flex" });
                }}
                onClick={(e) => {
                  setStyle({ display: "none" });
                }}
              >
                {tabDesktopContent.map((menu) => (
                  <li className="listing-dropdown">
                    <Link
                      to={menu.path}
                      className={(isArray(menu.parent) ? menu.parent.some((item) => pathname.includes(item)) : pathname.includes(menu.parent)) ? `active` : ``}
                    >
                      <span>
                        {typeof menu.title === "string"
                          ? parse(menu.title)
                          : menu.title}
                      </span>
                    </Link>
                    <ul
                      id="first-level"
                      tabIndex="0"
                      style={style}
                      onMouseLeave={(e) => {
                        setStyle({ display: "none" });
                      }}
                    >
                      {_.has(menu, "children") &&
                        menu.children.map((child) => (
                          <li>
                            <p
                              style={{
                                padding: "10px 20px 0 20px",
                                marginBottom: "10px",
                                color: "#000045",
                              }}
                            >
                              {parse(child.type)}
                            </p>
                            {child.children.map((item) => {
                              return _.has(item, "children") ? (
                                <div className="d-flex justify-content-start align-items-start">
                                  <p className="banca-takaful">
                                    {parse(item.title)}
                                    <img
                                      src={right_arrow}
                                      alt=""
                                      width="15px"
                                      className="pb-1"
                                    />
                                  </p>
                                  <div className="d-flex flex-column banca-takaful-item">
                                    {item.children.map((subItem) => (
                                      <Link to={subItem.path}>
                                        {parse(subItem.title)}
                                      </Link>
                                    ))}
                                  </div>
                                </div>
                              ) : (
                                <div className={item.image ? `my-3` : ``}>
                                  {item.image && (
                                    <img
                                      src={item.image}
                                      alt=""
                                      className="ms-3 cursor-pointer"
                                      width="200"
                                      onClick={() => navigate(item.path)}
                                    />
                                  )}
                                  <Link to={item.path}>
                                    {parse(item.title)}
                                  </Link>
                                </div>
                              );
                            })}
                          </li>
                        ))}
                    </ul>
                  </li>
                ))}
              </ul>
              <i
                className="mobile-nav-toggle d-xl-none bi bi-list"
                onClick={toggleMenu}
              ></i>
            </nav>

            <p className="btn-getstarted flex-md-shrink-0 ms-auto p-0">
              <LoginButton popupStyle={{ left: "-160px" }} />
            </p>
          </div>
          {/* mobile navigation */}
          <Offcanvas show={isMenuOpen} onHide={toggleMenu} placement="end">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                <LoginButton />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Accordion defaultActiveKey="0" id="mobile-menu">
                <Accordion.Item
                  eventKey="4"
                  onClick={() => {
                    navigate("/");
                    toggleMenu();
                  }}
                >
                  <Accordion.Header
                    style={{ lineHeight: "44px"}}
                    >Home</Accordion.Header>
                </Accordion.Item>
                {tabItems.map((category) => (
                  <Accordion.Item
                    eventKey={category.id}
                    onClick={() => {
                      setTabDesktopContent(category.item);
                      setTab(category.id);
                    }}
                  >
                    {/* <Accordion.Header>{parse(category.name)}</Accordion.Header> */}
                    <Accordion.Header>
                      <span
                        className="d-inline-block w-100"
                        style={{ lineHeight: "44px"}}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (category.path === undefined) return;
                          navigate(category.path);
                          toggleMenu();
                        }}
                      >
                        {parse(category.name)}
                      </span>
                      <img
                        onClick={(e) => {
                          // e.stopPropagation();
                          setActiveParent(category.id);
                          setActiveKey('100');
                          e.target.classList.toggle("rotate-90");
                        }}
                        src={right_arrow}
                        width="18"
                        className={`accordion-toggle d-inline-block align-top ${
                          activeParent === category.id ? 'rotate-90' : ''
                        }`}          
                        alt="plus"
                      />
                    </Accordion.Header>

                    <Accordion.Body>
                      {convertToMobileMenu.map((menu) => (
                        <Accordion defaultActiveKey={activeKey} activeKey={activeKey} onSelect={(key) => setActiveKey(key)} id="mobile-menu">
                          <Accordion.Item eventKey={`${menu.id}00`} key={menu.id}>
                            <Accordion.Header>
                              <span
                                className="d-inline-block w-100"
                                style={{ lineHeight: "44px"}}
                                onClick={() => {
                                  if(activeKey === `${menu.id}00`) {
                                    setActiveKey(null);
                                  }else{
                                    setActiveKey(`${menu.id}00`);
                                  }
                                  if (menu.path === undefined) return;
                                  // else if (menu.path === "/rize/personal") return;
                                  navigate(menu.path);
                                  toggleMenu();
                                }}
                              >
                                {menu.title}
                              </span>
                              {
                                menu.children && 
                                  <img
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      setActiveKey(`${menu.id}00`);
                                      e.target.classList.toggle("rotate-90");
                                    }}
                                    src={right_arrow}
                                    width="18"
                                    className={`accordion-toggle d-inline-block align-top margin-right-5px ${
                                      `${menu.id}00` === activeKey ? "rotate-90" : ""
                                    }`}
                                    alt="plus"
                                  />
                              }
                            </Accordion.Header>
                            <Accordion.Body>
                              {_.isArray(menu.children) &&
                                menu.children.map((child) => (
                                  <Link
                                    to={!_.has(child, "children") && child.path}
                                    onClick={!_.has(child, "children") && toggleMenu}
                                  >
                                    <div className="mobile-list list">
                                      <span className={child.children && `d-inline-flex justify-content-between w-100`}>{parse(child.title)}
                                      {child.children && (
                                        <img
                                          src={right_arrow}
                                          width="18"
                                          className="d-inline-block rotate-90 align-top margin-right-5px "
                                          style={{ filter: 'grayscale(1)', opacity: 0.2 }}
                                          alt="plus"
                                        />
                                      )}
                                      </span>
                                      {_.has(child, "children") && (
                                        <div className="d-flex flex-column ps-4">
                                          {_.isArray(child.children) &&
                                            child.children.map(
                                              (grandChild, index) => (
                                                <Link
                                                  to={grandChild.path}
                                                  onClick={toggleMenu}
                                                >
                                                  {/* <div
                                                    className={`mobile-list list pe-0 me-0 
                                                      ${
                                                      index === 0 ? `mt-3` : ``
                                                    }
                                                    `}
                                                  > */}
                                                  <div
                                                    className={`mobile-list list pe-0 me-0 
                                                      ${
                                                        index === 0 ? `mt-2` : ``
                                                      }
                                                      `}
                                                  >
                                                    <span>
                                                      {parse(grandChild.title)}
                                                    </span>
                                                    {/* <img
                                                      src={right_arrow}
                                                      width="18"
                                                      className="d-inline-block align-top margin-right-5px"
                                                      alt="plus"
                                                    /> */}
                                                  </div>
                                                </Link>
                                              )
                                            )}
                                        </div>
                                      )}
                                    </div>
                                  </Link>
                                ))}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
                <Accordion.Item
                  eventKey="5"
                  onClick={() => {
                    navigate("/news");
                    toggleMenu();
                  }}
                >
                  <Accordion.Header 
                    style={{ lineHeight: "44px"}}
                  >News</Accordion.Header>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="6"
                  onClick={() => {
                    navigate("/contact-us");
                    toggleMenu();
                  }}
                >
                  <Accordion.Header 
                    style={{ lineHeight: "44px"}}
                  >Contact Us</Accordion.Header>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="7"
                  onClick={() => {
                    navigate("/contact-us");
                    toggleMenu();
                  }}
                >
                  <Accordion.Header 
                    style={{ lineHeight: "44px"}}
                  >Location</Accordion.Header>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="8"
                  onClick={() => {
                    window.location.replace("https://www.alrajhibank.com.sa");
                    toggleMenu();
                  }}
                >
                  <Accordion.Header 
                    style={{ lineHeight: "44px"}}
                  >Global Site</Accordion.Header>
                </Accordion.Item>
              </Accordion>
            </Offcanvas.Body>
          </Offcanvas>
        </header>
      </div>
    </header>
  );
}

export default MainHeader;
